import classNames from 'classnames';
import ReactSelect, { Props, GroupBase } from 'react-select';
import { SelectOptionProps } from './Select';

type MultiSelectValue = unknown;
type MultiSelectIsMulti = true;

interface MultiSelectProps
  extends Props<MultiSelectValue, MultiSelectIsMulti, GroupBase<MultiSelectValue>> {
  className?: string;
  inputClassName?: string;
  error?: string | boolean;
  label?: string | React.ReactElement;
  labelIcon?: React.ReactElement;
  options: SelectOptionProps[];
  labelRef?: React.RefObject<HTMLLabelElement | null>;
  disabled?: boolean;
}

function MultiSelect({
  className,
  inputClassName,
  label,
  error,
  options,
  disabled = false,
  labelIcon,
  labelRef,
  ...rest
}: MultiSelectProps) {
  return (
    <div className={classNames('mb-2', className)}>
      <label
        className={classNames(
          'text-heading flex flex-col font-semibold',
          label && error && 'text-red-600'
        )}
        ref={labelRef}
      >
        {label && (
          <div className="mb-1 flex min-h-5 items-center gap-1 leading-none">
            {labelIcon && <div>{labelIcon}</div>}
            <div>{label}</div>
          </div>
        )}
        <div className="bg-red-500 focus:outline-4 focus:outline-blue-200 focus:outline-solid">
          <ReactSelect
            className="bg-blue-400"
            classNames={{
              container: () => '',
              control: () =>
                classNames(
                  'h-11 w-full rounded border border-neutral-500 bg-white font-normal outline-none outline-offset-1',
                  disabled && 'border-neutral-500/30 text-neutral-500',
                  error && 'border-red-600 text-red-600',
                  'focus:outline-4 focus:outline-blue-200 focus:outline-solid',
                  'px-2',
                  inputClassName
                ),
              menu: () => 'border-neutral-500 border bg-white rounded',
              menuList: () => '',
              option: () => 'p-2 hover:bg-blue-50',
              input: () => ' focus:outline-4 focus:outline-blue-200 focus:outline-solid',
              valueContainer: () => 'gap-2',
              multiValue: () =>
                'pl-2 pr-1, py-1 bg-neutral-200 border-0 border-neutral-500 rounded font-semibold',
              multiValueRemove: () => 'px-1',
            }}
            options={options}
            isMulti
            isDisabled={disabled}
            unstyled
            {...rest}
          />
        </div>
      </label>
      {error && typeof error === 'string' && (
        <div className="mt-2 rounded bg-red-50 px-2 py-1 text-red-700">{error}</div>
      )}
    </div>
  );
}

export default MultiSelect;
